<template>
  <pt-detection-detail class="pt-detection-detail__page"></pt-detection-detail>
</template>

<script>
import PtDetectionDetail from 'cps/gene-product/pt-detection-detail/withData'
export default {
  name: 'pt-detection-detail__view',
  components: {
    'pt-detection-detail': PtDetectionDetail
  }
}
</script>
